//  Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { AnalysisTypeIdEnum } from 'config/enums'
import { castToString } from 'helpers/reduxFormFunctions'
import { push } from 'react-router-redux'
import initializeAFSGridFilter from 'redux/modules/interferenceAnalysis/thunks/initializeAFSGridFilter'
import { initializeEarthStationResultsForm } from 'components/InterferenceAnalysis/EarthStationResults/helpers'

const goToEarthStationResults = ({ bandId, projectId }) => async dispatch => {
  const afsGridFilterOverrideValues = {
    analysisTypeId: castToString(AnalysisTypeIdEnum.EARTH_STATION),
    bandId: castToString(bandId),
  }

  const pathname = `/project-management/${projectId}/interference-analysis/earth-station`

  // if we're already on the 'newRoute',
  // then we need to manually trigger the ES Results to update.
  // otherwise go to there!
  // NOTE - this is assuming hash routing
  if (window.location.hash === `#${pathname}`) {
    await dispatch(initializeAFSGridFilter(afsGridFilterOverrideValues))
    dispatch(initializeEarthStationResultsForm())
  } else {
    dispatch(push({
      pathname,
      state: {
        afsGridFilterOverrideValues,
      }
    }))
  }
}

export default goToEarthStationResults
